/**
 * Detect whether the browser meets the minimum requirements for the client uploader.
 *
 * Per plan.md §3.1: WebCrypto and WebAssembly are required (used for client-side
 * encryption via age/typage in Phase L1). If either is missing we render a Hebrew
 * "your browser is too old" page rather than a white screen of death.
 */

export function isBrowserSupported(): boolean {
  if (typeof crypto === "undefined") return false;
  if (typeof crypto.subtle === "undefined") return false;
  if (typeof WebAssembly === "undefined") return false;
  if (typeof TextEncoder === "undefined") return false;
  return true;
}
